import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Support / aide humaine — casque audio avec micro duotone */
export const SupportIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Coussinets oreilles menthe */}
      <rect x="3" y="11.5" width="4.5" height="7" rx="1.5" fill="var(--equiply-icon-bg)" />
      <rect x="16.5" y="11.5" width="4.5" height="7" rx="1.5" fill="var(--equiply-icon-bg)" />
      {/* Arceau */}
      <path
        d="M4 12.5a8 8 0 0 1 16 0"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
      {/* Coussinets contour */}
      <rect x="3" y="11.5" width="4.5" height="7" rx="1.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      <rect x="16.5" y="11.5" width="4.5" height="7" rx="1.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Micro */}
      <path
        d="M16.5 18.5v.5a2 2 0 0 1-2 2H12"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
    </svg>
  ),
);
SupportIcon.displayName = "SupportIcon";
